import { render, staticRenderFns } from "./AgendaComponent.vue?vue&type=template&id=5735c0f3&"
import script from "./AgendaComponent.vue?vue&type=script&lang=js&"
export * from "./AgendaComponent.vue?vue&type=script&lang=js&"
import style0 from "./AgendaComponent.vue?vue&type=style&index=0&id=5735c0f3&prod&lang=css&"
import style1 from "./AgendaComponent.vue?vue&type=style&index=1&id=5735c0f3&prod&lang=css&"
import style2 from "./AgendaComponent.vue?vue&type=style&index=2&id=5735c0f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports